import { render, staticRenderFns } from "./DialogTour.vue?vue&type=template&id=1a6f51f0&scoped=true&"
import script from "./DialogTour.vue?vue&type=script&lang=ts&"
export * from "./DialogTour.vue?vue&type=script&lang=ts&"
import style0 from "./DialogTour.vue?vue&type=style&index=0&id=1a6f51f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6f51f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VImg,VRow})
